import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as AnalysisResultsTextSelectors from '../selectors/analysis-results-text.selectors';
import * as AnalysisResultsTextStore from '../reducers/analysis-results-text.reducer';
import { AnalysisResultsTextCommon } from '@sleipai/sleip-models';
import { Observable } from 'rxjs';

@Injectable()
export class AnalysisResultsTextStoreFacade {
  constructor(private readonly store: Store<AnalysisResultsTextStore.State>) {}

  getAnalysisResultsTextsByIds$ = (ids: string[]) =>
    this.store.pipe(
      select(AnalysisResultsTextSelectors.selectAnalysisResultsTextsByIds(ids))
    );

  getAnalysisResultsTexts$ : Observable<AnalysisResultsTextCommon[]>= this.store.pipe(
    select(AnalysisResultsTextSelectors.selectAllAnalysisResultsText)
  );
}
